import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { BaseCardSetDetailComponent } from '../base-card-set-detail-component/base-card-set-detail.component';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { CardSetTransformationService, CoreService, DataService, DialogService, SaveDataRequest, SaveFormEvent, SpinnerService } from 'dspx-core';
import { AppDataService } from 'src/app/services/app-data.service';
import { API_ENDPOINT_KEYS, API_ENDPOINTS } from 'src/app/constants/api-endpoints.constants';
import { TEMPLATES, VERSIONS } from 'src/app/constants/templates.constants';
import { POP_UP_CODES, SAVE_RESULT_STATUS } from 'src/app/constants/app-data.constants';
import { ROUTE_CONSTANTS } from 'src/app/constants/route.constants';
import { take, finalize } from 'rxjs';
import { ErrorService } from 'src/app/services/error.service';
import { VptasSpecialistSaveDataRequest } from 'src/app/interfaces/vptas-specialist-save-data-request';

@Component({
  selector: 'app-vptas-specialist',
  templateUrl: './vptas-specialist.component.html',
  styleUrl: './vptas-specialist.component.scss'
})
export class VptasSpecialistComponent extends BaseCardSetDetailComponent implements OnInit, OnDestroy {

  protected readonly fieldTypeReplacements = CardSetTransformationService.cardSetWithFlatTabsFieldTypeReplacements;

  formServiceEndpoint: string = API_ENDPOINT_KEYS.getFormConfig;
  //API_ENDPOINT_KEYS.getVptasSpecialistConfig;

  templateId: number = TEMPLATES.vptasSpecialist;
  versionNo: number = VERSIONS.latest;
  model: any;
  activeDialog: string = '';
  id: string = '';
  showProviderInformationSection: boolean = false;
  isNew: boolean = true;

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected appDataService: AppDataService,
    protected dialogService: DialogService,
    private coreService: CoreService,
    private dataService: DataService,
    private errorService: ErrorService,
    private spinnerService: SpinnerService,
    private changeDetector: ChangeDetectorRef,

  ) {
    super(router, appDataService, dialogService);
  }
  ngOnInit(): void {
    this.coreService.applicationFunctions = {

    }
    this.coreService.conditionFunctions =
    {
      showProviderInformationSection: () => !this.isNew,
    }
    this.registerSubscription(
      this.route.paramMap.subscribe((paramMap: ParamMap) => {
        const specialistId = paramMap.get('id');
        if (specialistId) {
          this.id = specialistId;
          this.formServiceEndpoint = API_ENDPOINT_KEYS.getVptasSpecialistConfig;
          this.isNew = false;
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.unsubscribeSubscriptions();
    this.coreService.applicationFunctions = {};
    this.coreService.repeatingPageFunctions = {};
    this.coreService.repeatingSectionFunctions = {};
  }

  formLoaded(event: any): void {

  }

  buttonClicked(event: any): void {
  }

  filter(event: any): void {
  }

  modelChanged(event: any): void { }

  save(event: SaveFormEvent) {
    if (!event.isFormValid) {
      this.baseForm.markAllFieldsAsTouched();
      this.baseForm.showValidationSummary(true);
      this.dialogService.showPopup(POP_UP_CODES.common.validationError);
    }

    const saveDataRequest: VptasSpecialistSaveDataRequest = {
      template: this.templateId,
      versionNumber: this.versionNo,
      id: this.id,
      response: event.model,
      expectedLastUpdateTime: event.lastUpdatedTime,
      isSubmit: false,
      isNew: this.isNew
    }
    this.saveData(saveDataRequest);
  }

  cancel(event: any) {
    this.exit();
  }

  actionButton_providerInformationGrid_datagrid_custom_addProviderInformation_Clicked(event: any) {
    //this.router.navigate(['/', ROUTE_CONSTANTS.careAllowanceApplication.prefix, ROUTE_CONSTANTS.applicationDetailCreateUpdateCarer.prefix, event.event.data.id]);
    this.router.navigate([ROUTE_CONSTANTS.VptasSpecialistProviderInformation.prefix, ROUTE_CONSTANTS.VptasSpecialistProviderInformation.specialist, this.id]);
  }

  actionButton_providerInformationGrid_datagrid_edit_Clicked(event: any): void {
    this.router.navigate(['/', ROUTE_CONSTANTS.VptasSpecialistProviderInformation.prefix, ROUTE_CONSTANTS.VptasSpecialistProviderInformation.specialist, this.id, event.event.data.id]);
  }

  private saveData(request: SaveDataRequest) {
    this.spinnerService.showSpinner();
    this.dataService.saveData(API_ENDPOINTS.vptasSpecialist.save, request)
      .pipe(
        take(1),
        this.errorService.errorHandler(),
        finalize(() => this.spinnerService.hideSpinner())
      )
      .subscribe(data => {
        if (data?.status === SAVE_RESULT_STATUS.success) {
          this.isNew = false;
          this.id = data.id;
          // Trigger condition functions to re-evaluate
          this.model = { ...this.baseForm.model };
          this.changeDetector.detectChanges();
          this.dialogService.showSimplePopup("Success", "Data saved successfully.");
        }
      });
  }
  private exit(ignoreUnsavedChanges = false): void {
    this.navigate([ROUTE_CONSTANTS.VptasSpecialist.list], ignoreUnsavedChanges);
  }

}